let baseUrl = ''
if (typeof window !== 'undefined') {
  baseUrl = ''
} else if(process.env.ip){
  if (process.env.NODE_ENV === 'test') { // 测试环境
    baseUrl = 'http://'+process.env.ip+':'+(process.env.PORT || 9097)
  } else if(process.env.NODE_ENV === 'production') { // 生产环境
        baseUrl = 'https://www.zqcf918.com'
  }else{  //开发环境
    baseUrl = 'http://'+process.env.ip+':'+(process.env.PORT || 9097)
  }
}

export const isProduction = process.env.NODE_ENV === 'production'
export const officialHost = isProduction
  ? 'https://www.zqcf918.com'
  : 'http://testwww.zqcf618.com'
export const communityHost = isProduction
  ? 'https://sq.zqcf918.com'
  : 'http://testweb.zqcf618.com'

export default baseUrl;
